import React, { useState } from "react";
import {
  Label,
  UserRoleType,
  LabelEntityType,
} from "@api/graphql/generated/generated-types";
import { LabelBadge } from "./LabelBadge";
import { LabelAssignmentPopover } from "./LabelAssignmentPopover";
import { useAuth } from "@src/common/hooks/useAuth";

interface AssignedLabelsSectionProps {
  entityLabels: Label[] | undefined;
  entityId: string;
  onLabelAssignmentChanged: (res: any) => void;
  onLabelCreated?: () => void | undefined;
  entityType: LabelEntityType;
}

export function AssignedLabelsSection({
  entityLabels,
  entityId,
  onLabelAssignmentChanged,
  onLabelCreated = undefined,
  entityType,
}: AssignedLabelsSectionProps) {
  const { isRoleType } = useAuth();
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const handleOpenPopover = () => {
    setIsPopoverOpen(true);
  };

  const handleClosePopover = () => {
    setIsPopoverOpen(false);
  };

  if (!entityLabels) {
    return null;
  }

  return (
    <div className="space-y-3">
      <span className="font-semibold">Labels</span>
      <div className="flex flex-wrap gap-2">
        {entityLabels.length === 0 ? (
          <div className="text-gray-500 text-sm">No labels found</div>
        ) : (
          entityLabels.map((label) => (
            <LabelBadge
              key={label.id}
              label={label}
              onClick={handleOpenPopover}
            />
          ))
        )}
        {isRoleType(UserRoleType.Administrator) && (
          <LabelAssignmentPopover
            selectedLabels={entityLabels}
            isPopoverOpen={isPopoverOpen}
            onOpenPopover={handleOpenPopover}
            onClosePopover={handleClosePopover}
            entityId={entityId}
            onLabelAssignmentChanged={onLabelAssignmentChanged}
            onLabelCreated={onLabelCreated}
            entityType={entityType}
          />
        )}
      </div>
    </div>
  );
}
